
import { env } from '@env';
import { HttpRequestData, httpUtil, PaginationResponse } from '@/framework';

export interface GetReportBookingByServiceCategoryDetailRequest extends HttpRequestData {
    readonly query: {
        readonly salonId: number;
        readonly startDate: string;
        readonly endDate: string;
    }
}

export interface GetReportBookingByServiceCategoryDetailItem  {
    readonly totalRevenueBooking: number;
    readonly totalQuantity: number;
    readonly serviceCategoryName?: string;
    readonly serviceCategoryId?: number;
    readonly salonId?: number;
    readonly salonBranchId?: number;
}

export const getReportBookingByServiceCategoryDetail = httpUtil.createHttpRequestMeta<
    GetReportBookingByServiceCategoryDetailRequest,
    PaginationResponse<GetReportBookingByServiceCategoryDetailItem>
>({
    baseUrl: env.orgServer,
    path: '/bookings/by-service-category-detail',
    method: 'GET',
    authentication: 'bearer'
});
